module.exports = __webpack_public_path__ + "static/joanna-kosinska-1_CMoFsPfso-unsplash 2-56933b1b0b9d483e77db4eef9be9339f.png";